import { ListPage } from '@components/molecules';
import { TextFieldElement } from 'react-hook-form-mui';
import API from '@apps/localization/services/unit';
import { ModelProps } from '@/types';
import { UnitSchema, UnitSearchSchema } from '@apps/localization/schemas/unit';
import { GridColDef } from '@mui/x-data-grid';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { YesNoAutocompleteElement } from '@/components/atoms';
import AsyncAutocompleteElement from '@/components/atoms/asyncautocomplete';
import CityAPI from '@apps/localization/services/city';
import DivisionAPI from '@apps/localization/services/division';

export default function ObjectListPage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t('Name'),
      flex: 1,
    },
    {
      field: 'division_str',
      headerName: t('Identified Area'),
      flex: 1,
      sortable: false,
    },
    {
      field: 'acronym',
      headerName: t('Acronym'),
      width: 250,
    },
    {
      field: 'city',
      headerName: t('City'),
      width: 250,
      valueFormatter: (params: { id: number; label: string }) => {
        return params.label;
      },
    },
    {
      field: 'sap_code',
      headerName: t('Sap Code'),
      width: 250,
    },
    {
      field: 'is_active',
      headerName: t('Is Active?'),
      width: 120,
      type: 'boolean',
    },
  ];

  return (
    <ListPage
      schema={UnitSchema}
      schemaSearch={UnitSearchSchema}
      title={t('Unit')}
      api={API}
      columns={columns}
      modelProps={modelProps}
      initialState={{
        sorting: {
          sortModel: [{ field: 'name', sort: 'asc' }],
        },
      }}
    >
      <Grid size={{ xs: 12, md: 2 }}>
        <TextFieldElement name="search" label={t('Search')} fullWidth />
      </Grid>
      <Grid size={{ xs: 12, md: 2 }}>
        <AsyncAutocompleteElement
          api={CityAPI.select}
          name="city"
          label={t('City')}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 2 }}>
        <AsyncAutocompleteElement
          api={DivisionAPI.select}
          name="division"
          label={t('Identified Area')}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 2 }}>
        <YesNoAutocompleteElement name="is_active" label={t('Is Active?')} />
      </Grid>
    </ListPage>
  );
}
